import React from "react";
//import PropTypes from 'prop-types';
import useStyles from "./styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
//import MenuIcon from '@material-ui/icons/Menu';
// import SearchIcon from "@material-ui/icons/Search";
//import DirectionsIcon from '@material-ui/icons/Directions';
import ClearIcon from "@material-ui/icons/Clear";
export const SearchWidget = ({
  name,
  value,
  className,
  onChange,
  onEnter,
  onClear,
  placeholder,
  ...props
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Paper
        component="form"
        className={classes.root}
        style={props.style ? props.style : null}
      >
        <InputBase
          className={classes.input}
          placeholder={placeholder ? placeholder : "Search by User Id"}
          inputProps={{ "aria-label": "search user id" }}
          onChange={onChange}
          value={value}
        />
        <IconButton
          type="submit"
          className={classes.iconButton}
          aria-label="search"
          onClick={onEnter}
        >
          <SearchIcon />
        </IconButton>
        <Divider className={classes.divider} orientation="vertical" />
        <IconButton
          color="primary"
          className={classes.iconButton}
          aria-label="directions"
          onClick={onClear}
        >
          <ClearIcon />
        </IconButton>
      </Paper>
    </React.Fragment>
  );
};
